import { AnimatedContainer } from '@avanta/shared/components/AnimatedContainer';
import { Text } from '@avanta/shared/components/Text';
import { Button } from '@avanta/shared/components/ui/Button';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';
import { changeFlow, hasFixedPsychologist } from 'pages/AppointmentsReserve/utils';

export const SearchPsychologistBanner = (): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { control, setValue } = useFormContext<AppointmentsReserveFormData>();
  const flow = useWatch({ control, name: AppointmentsReservePayload.flow });

  if (hasFixedPsychologist(flow)) return null;

  const handleClick = (): void => {
    setValue(AppointmentsReservePayload.dateTime, '');
    setValue(AppointmentsReservePayload.psychologist, undefined);
    changeFlow(setValue, flow, FLOW_MODES.search_facultative);
  };

  return (
    <AnimatedContainer transition={{ duration: 0.25, ease: 'easeInOut' }}>
      <div className="w-full bg-plum-100 pl-4 pr-6 py-3 flex justify-between items-center rounded-xl">
        <div>
          <Text variant="text-sm-medium" className="text-denim-800">
            {t('AppointmentsReserve.SearchFacultativeBanner.title')}
          </Text>
          <Text variant="text-sm-medium" className="text-denim-800">
            {t('AppointmentsReserve.SearchFacultativeBanner.description')}
          </Text>
        </div>
        <Button
          variant="link"
          className="text-teal-600 underline underline-offset-2 font-medium text-sm leading-4 hover:text-teal-500 p-0"
          onClick={handleClick}
        >
          {t('AppointmentsReserve.SearchPsychologist.cta')}
        </Button>
      </div>
    </AnimatedContainer>
  );
};
